import React, { useState } from 'react';
import { TMDB_IMG } from '../api/api';

const MovieCard = ({ itemId, itemTitle, itemRole, itemImgUrl, isActor, onClickFunction }) => {
  const [imgError, setImgError] = useState(false);

  const imgClasses = isActor
    ? 'w-10 h-10 rounded-full object-cover border-2 border-[#1a1a1a] flex-shrink-0'
    : 'w-9 h-[52px] rounded object-cover border-2 border-[#1a1a1a] flex-shrink-0';

  const fallbackClasses = isActor
    ? 'w-10 h-10 rounded-full bg-[#f0e6d3] border-2 border-[#1a1a1a] flex-shrink-0 flex items-center justify-center text-lg'
    : 'w-9 h-[52px] rounded bg-[#f0e6d3] border-2 border-[#1a1a1a] flex-shrink-0 flex items-center justify-center text-lg';

  return (
    <div
      data-testid="movie-card"
      onClick={() => onClickFunction(itemId)}
      className="bg-white border-[3px] border-[#1a1a1a] rounded-xl p-3 flex items-center gap-3 shadow-[3px_3px_0_#1a1a1a] cursor-pointer hover:shadow-[1px_1px_0_#1a1a1a] transition-shadow"
    >
      {itemImgUrl && !imgError ? (
        <img
          src={`${TMDB_IMG}${itemImgUrl}`}
          alt={itemTitle}
          onError={() => setImgError(true)}
          className={imgClasses}
        />
      ) : (
        <div className={fallbackClasses}>
          {isActor ? '🎭' : '🎬'}
        </div>
      )}
      <div className="text-left">
        <p className="text-sm font-bold text-[#1a1a1a]">{itemTitle}</p>
        <p className="text-xs text-[#888]">{itemRole}</p>
      </div>
    </div>
  );
};

export default MovieCard;
